module.exports = __webpack_public_path__ + "img/nextimg.586dc5d5.png";